import React from "react";
import { useTranslate } from "react-admin";
import TablePagination from '@material-ui/core/TablePagination';
import Box from '@material-ui/core/Box';

import { httpClient } from "../../../api/httpClient";
import { toDate } from "../../_helpers/dateTime";
import { AutoTable } from "./AutoTable";

import { getTotalFromHeaderRange } from "utils/http";
import { isNullUndEmpty } from "utils/general";
import { useNotifyError } from "utils/notifiers/useNotifyError";

export const fetchDataForExport = (
	httpClient,
	endpoint,
	filter,
	type = "json",
	order = ["id", "DESC"],
	range = [0, 19]
) => {
	const querystringMap = {"order": order, "filter": filter, "range": range};
	const querystringPayload = [];
	Object.entries(querystringMap).forEach(([key, value]) => {
		if (!isNullUndEmpty(value)) {
			const encodedValue = encodeURIComponent(JSON.stringify(value))
			querystringPayload.push(`${key}=${encodedValue}`);
		}
	});

	const querystring = querystringPayload.join("&")
	const path = `/${endpoint}-export.${type}`;

	let url = path;
	if (!isNullUndEmpty(querystring)) {
		url = `${path}?${querystring}`
	}

	return httpClient(url);
};

const rowsPerPageOptions = [200, 500, 1000];

export const DataExportTable = React.forwardRef(
	({ filters, setExportDate, endpoint, sort }, tableRef) => {
		const [loading, setLoading] = React.useState(true);
		const [data, setData] = React.useState({ header: [], rows: [] });
		const [totalPages, setTotalPages] = React.useState(1);
		const [page, setPage] = React.useState(0);
		const [rowsPerPage, setRowsPerPage] = React.useState(rowsPerPageOptions[0]);
		const translate = useTranslate();
		const notifyError = useNotifyError();
		// const itemsPerPage = 20;
		React.useEffect(() => {
			setLoading(true);
			fetchDataForExport(httpClient, endpoint, filters, "json", sort, [
				page * rowsPerPage,
				page * rowsPerPage + rowsPerPage - 1,
			])
				.then((res) => {
					const exportDateRaw = res.headers.get("x-date");
					const exportDate = toDate(exportDateRaw);
					if (setExportDate) setExportDate(exportDate);
					
					const total = getTotalFromHeaderRange(res);
					(total || total === 0) && setTotalPages(total);

					setData(res.json);
					setLoading(false);
				})
				.catch((err) => {
					notifyError(err);
				})
				.finally(() => {
					setLoading(false);
				});
		}, [JSON.stringify(filters), page, rowsPerPage]); // eslint-disable-line react-hooks/exhaustive-deps

		const handleChangePage = (event, newPage) => {
			setPage(newPage);
		};

		const handleChangeRowsPerPage = (event) => {
			setRowsPerPage(parseInt(event.target.value));
			setPage(0);
		};

		return (
			// to have pagination below the table, to be always visible, 
			// otherwise it will be hidden because of the length of rows and will require scrolling to be accessed
			<Box style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
				<Box style={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
					<AutoTable
						ref={tableRef}
						loading={loading}
						header={data && data.header}
						rows={data && data.rows}
						emptyTitle={translate(`osfc.dialogs.${endpoint}.title.empty`)}
					/>
				</Box>
				{!loading && data && data.rows && data.rows.length > 0 && (
					<Box
						style={{
							flexShrink: 0,
							backgroundColor: 'white',
							borderTop: '1px solid #e0e0e0',
							display: 'flex',
							justifyContent: 'flex-end',
							padding: '8px 16px'
						}}
					>
						<TablePagination
							component="div"
							rowsPerPageOptions={rowsPerPageOptions}
							count={totalPages}
							rowsPerPage={rowsPerPage}
							page={page}
							SelectProps={{
								inputProps: { 'aria-label': 'rows per page' },
								native: true,
							}}
							onChangePage={handleChangePage}
							onChangeRowsPerPage={handleChangeRowsPerPage}
						/>
					</Box>
				)}
			</Box>
		);
	}
);
